"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionModel = void 0;
const instructor_model_1 = require("../instructor/instructor.model");
const partner_model_1 = require("../partner/partner.model");
const sessioncontact_model_1 = require("./sessioncontact.model");
const sessionlight_model_1 = require("./sessionlight.model");
const package_model_1 = require("./package.model");
const option_model_1 = require("./option.model");
const ambassador_model_1 = require("./ambassador.model");
class SessionModel extends sessionlight_model_1.SessionLightModel {
    constructor(sessionData = null, deepClone = true) {
        super(null, false, 'SessionModel');
        this.bannerUrl = "";
        this.bannerUrlAlt = "";
        this.scholarship = false;
        this.brochureAvailable = false;
        this.brochureBooking = false;
        this.brochureUrl = "";
        this.onSaleDetail = "";
        this.audienceContent = "";
        this.durationDetail = "";
        this.creditDetail = "";
        this.courseType = "";
        this.admissionDetail = "";
        this.paymentDetail = "";
        this.courseSubType = "";
        this.subtitle = "";
        this.relatedSessionRef = [];
        this.relatedSession = [];
        this.linkedInstructors = [];
        this.instructors = [];
        this.sponsorContributor = [];
        this.contributorPartners = [];
        this.sponsorCollaboration = [];
        this.collaborationPartners = [];
        this.sessionContacts = new sessioncontact_model_1.SessioncontactModel();
        this.competencies = "";
        this.whoyouwill = "";
        this.reasonwhy = "";
        this.lessionTimeDetail = "";
        this.certificationIntro = "";
        this.modulesList = [];
        this.certificationList = [];
        this.updatedAt = null;
        this.adv = [];
        this.assets = [];
        this.tags = {};
        this.ranking = 0;
        this.options = [];
        this.packages = [];
        this.regionAccreditation = "";
        this.idCourseForAccreditation = "";
        this.ambassador = null;
        if (sessionData != null) {
            this.clone(sessionData, deepClone);
        }
    }
    clone(obj, deep = false) {
        super.clone(obj, deep);
        if (obj != null && typeof obj === 'object') {
            this.bannerUrl = obj.bannerUrl;
            this.bannerUrlAlt = obj.bannerUrlAlt;
            this.scholarship = obj.scholarship;
            this.brochureAvailable = obj.brochureAvailable;
            this.brochureBooking = obj.brochureBooking;
            this.brochureUrl = obj.brochureUrl;
            this.onSaleDetail = obj.onSaleDetail;
            this.audienceContent = obj.audienceContent;
            this.durationDetail = obj.durationDetail;
            this.creditDetail = obj.creditDetail;
            this.courseType = obj.courseType;
            this.admissionDetail = obj.admissionDetail;
            this.paymentDetail = obj.paymentDetail;
            this.discountPercent = obj.discountPercent;
            this.courseSubType = obj.courseSubType;
            this.subtitle = obj.subtitle;
            ;
            this.relatedSessionRef = obj.relatedSessionRef && obj.relatedSessionRef.length > 0 ? [...obj.relatedSessionRef] : [];
            this.linkedInstructors = obj.linkedInstructors && obj.linkedInstructors.length > 0 ? [...obj.linkedInstructors] : [];
            this.sponsorContributor = obj.sponsorContributor && obj.sponsorContributor.length > 0 ? [...obj.sponsorContributor] : [];
            this.sponsorCollaboration = obj.sponsorCollaboration && obj.sponsorCollaboration.length > 0 ? [...obj.sponsorCollaboration] : [];
            if (deep) {
                obj.relatedSession.forEach(v => this.relatedSession.push(new sessionlight_model_1.SessionLightModel(v, false)));
                obj.collaborationPartners.forEach(v => this.collaborationPartners.push(new partner_model_1.PartnerModel(v, false)));
                obj.contributorPartners.forEach(v => this.contributorPartners.push(new partner_model_1.PartnerModel(v, false)));
                obj.instructors.forEach(v => this.instructors.push(new instructor_model_1.InstructorModel(v, false)));
                this.sessionContacts = new sessioncontact_model_1.SessioncontactModel(obj.sessionContacts);
                obj.options.forEach(v => this.options.push(new option_model_1.OptionModel(v, false)));
                obj.packages.forEach(v => this.packages.push(new package_model_1.PackageModel(v, false)));
                this.ambassador = obj.ambassador ? new ambassador_model_1.AmbassadorModel(obj.ambassador) : null;
            }
            else {
                this.relatedSession = obj.relatedSession;
                this.collaborationPartners = obj.collaborationPartners;
                this.contributorPartners = obj.contributorPartners;
                this.instructors = obj.instructors;
                this.sessionContacts = obj.sessionContacts;
                this.options = obj.options;
                this.packages = obj.packages;
                this.ambassador = obj.ambassador ? obj.ambassador : null;
            }
            this.competencies = obj.competencies;
            this.whoyouwill = obj.whoyouwill;
            this.reasonwhy = obj.reasonwhy;
            this.lessionTimeDetail = obj.lessionTimeDetail;
            this.modulesList = obj.modulesList;
            this.certificationList = obj.certificationList;
            this.updatedAt = obj.updatedAt;
            this.adv = obj.adv;
            this.assets = obj.assets;
            this.tags = Object.assign({}, obj.tags);
            this.ranking = obj.ranking;
            this.admissionWithBuyAvailable = obj.admissionWithBuyAvailable;
            this.vatFree = obj.vatFree;
            this.certificationReleaseEntity = obj.certificationReleaseEntity.length > 0 ? [...obj.certificationReleaseEntity] : [];
            this.regionAccreditation = obj.regionAccreditation;
            this.idCourseForAccreditation = obj.idCourseForAccreditation;
        }
    }
    static fromJSON(d) {
        const instance = Object.assign(new SessionModel(), typeof d === 'string' ? JSON.parse(d) : d);
        return new SessionModel(instance);
    }
}
exports.SessionModel = SessionModel;
//# sourceMappingURL=session.model.js.map